import gql from 'graphql-tag';

export const MUTATION_ADD_FILE = gql`
  mutation addFile($filename: String!, $public: Boolean, $type: String) {
    addFile(input: { filename: $filename, public: $public, type: $type }) {
      id
      signedUploadUrl
    }
  }
`;



// WEBPACK FOOTER //
// ./src/services/graphql/file-query.js